import { W as WuiSelectInput$1, d as defineCustomElement$1 } from './select-input.js';

const WuiSelectInput = WuiSelectInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiSelectInput, defineCustomElement };

//# sourceMappingURL=wui-select-input.js.map